export default class ReportableException extends Error {
  constructor(jsonResponse) {
    // El backend retorna la estructura: { response: { message: "..." } }
    const message = jsonResponse?.response?.message || jsonResponse?.message || 'Ha ocurrido un error';
    super(message);
    // Guardar el JSON original para acceso posterior si es necesario
    this.jsonResponse = jsonResponse;
  }
}
